/* ChaiDirect UI behaviours: hero slider, scroll rails, daily countdown, header state */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    if (!root || root.dataset.chdInit === '1') return;
    root.dataset.chdInit = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-chd-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-chd-dot]'));
    var index = 0;
    var timer = null;
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === index);
        s.setAttribute('aria-hidden', n === index ? 'false' : 'true');
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === index);
      });
    }
    function start() {
      stop();
      if (delay > 0 && !prefersReduced) timer = setInterval(function () { show(index + 1); }, delay);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    var prev = root.querySelector('[data-chd-prev]');
    var next = root.querySelector('[data-chd-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.dataset.chdDot, 10)); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    /* touch swipe */
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(dx < 0 ? index + 1 : index - 1);
      startX = null;
      start();
    }, { passive: true });

    show(0);
    start();
  }

  /* ---------- Horizontal scroll rails ---------- */
  function initScroller(root) {
    if (!root || root.dataset.chdInit === '1') return;
    root.dataset.chdInit = '1';
    var track = root.querySelector('[data-chd-track]');
    var prev = root.querySelector('[data-chd-prev]');
    var next = root.querySelector('[data-chd-next]');
    if (!track) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      root.classList.toggle('at-start', track.scrollLeft <= 2);
      root.classList.toggle('at-end', track.scrollLeft >= max);
      root.classList.toggle('no-overflow', track.scrollWidth <= track.clientWidth + 2);
    }
    function step(dir) {
      var amount = Math.max(track.clientWidth * 0.8, 200);
      track.scrollBy({ left: dir * amount, behavior: prefersReduced ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 300);
  }

  /* ---------- Daily countdown (to local midnight) ---------- */
  function initCountdown(el) {
    if (!el || el.dataset.chdInit === '1') return;
    el.dataset.chdInit = '1';
    var h = el.querySelector('[data-chd-h]');
    var m = el.querySelector('[data-chd-m]');
    var s = el.querySelector('[data-chd-s]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      if (h) h.textContent = pad(Math.floor(diff / 3600));
      if (m) m.textContent = pad(Math.floor((diff % 3600) / 60));
      if (s) s.textContent = pad(diff % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Header scrolled state ---------- */
  function initHeaderState() {
    var last = -1;
    function onScroll() {
      var scrolled = window.scrollY > 8 ? 1 : 0;
      if (scrolled !== last) {
        document.body.classList.toggle('chd-scrolled', scrolled === 1);
        last = scrolled;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAll(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-chd-hero]'), initHero);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-chd-scroller]'), initScroller);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-chd-countdown]'), initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); initHeaderState(); });
  } else {
    initAll();
    initHeaderState();
  }

  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();